module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('div', {
    directives: [{
      name: "fileuploadk3",
      rawName: "v-fileuploadk3"
    }],
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "upload-change": _vm.uploadSuccess
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("Upload price Excel")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.exportPopShow = true;
        _vm.selectUser = ''
      }
    }
  }, [_vm._v("Export")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-table table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "Loading"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Product code",
      "prop": "Model",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "W",
      "prop": "Width",
      "min-width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "L",
      "prop": "Length",
      "min-width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Quantity",
      "prop": "Num",
      "min-width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Delivery date",
      "prop": "SupplyDay",
      "min-width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Unit price    (tax free)",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("priceHandle")(scope.row.PriceNoTax)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Unit price    (tax included)",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("priceHandle")(scope.row.Price)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Total           (tax free)",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("priceHandle")(scope.row.AllPriceNoTax)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Total             (tax included)",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("priceHandle")(scope.row.AllPrice)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Submit account",
      "prop": "Account",
      "min-width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Submit date",
      "min-width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("dateFormat")(scope.row.CreateTime)) + "\n          ")]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Export",
      "size": "tine"
    },
    model: {
      value: (_vm.exportPopShow),
      callback: function($$v) {
        _vm.exportPopShow = $$v
      },
      expression: "exportPopShow"
    }
  }, [_c('ExportForm', {
    attrs: {
      "url": "/Ajax/ProductListToExcelInAdmin",
      "extraData": {
        Account: _vm.selectUser,
        lang: 1
      }
    },
    on: {
      "FormClose": function($event) {
        _vm.exportPopShow = false
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Account"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Please select user account"
    },
    model: {
      value: (_vm.selectUser),
      callback: function($$v) {
        _vm.selectUser = $$v
      },
      expression: "selectUser"
    }
  }, _vm._l((_vm.userData), function(item, idx) {
    return _c('el-option', {
      key: idx,
      attrs: {
        "label": item.Account,
        "value": item.Account
      }
    })
  }), 1)], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Online inquiry view")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-0881ce7f","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/page/product/EnquiryOnlineSubmitManagement.vue
// module id = 723
// module chunks = 1